/* eslint-disable no-undef */
import {
  fetchData,
  fetchMultiData
} from './ajax'

// 主题服务页面涉及接口start
export function loadDealInfo (data, callFunc) {
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadDealInfo.v`, data, 'get', callFunc)
}
export function loadRelatedItemList (data, callFunc) {
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadRelatedItemList.v`, data, 'get', callFunc)
}
export function loadTypeStuffListByTypeSeq (data, callFunc) {
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/loadTypeStuffListByTypeSeq.v`, data, 'get', callFunc)
}
// 获取地区列表--get
export function getAreaList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/CommonService/api/area/areaList/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/CommonService/api/area/areaList/query.v`, data, 'get')
}
// 获取某个地区信息--get
export function getAreaInfo (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/CommonService/api/area/areaInfo/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/CommonService/api/area/areaInfo/query.v`, data, 'get')
}
// 获取一件事分类列表--get
export function getThemeTypeList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/themeTypeList/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/themeTypeList/query.v`, data, 'get')
}
// 获取场景下的主题信息（一件事）--get
export function loadThemeList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/loadThemeList/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadThemeList/query.v`, data, 'get')
}
// 主题服务页面涉及接口end

// 情景式问卷页面涉及接口start
// 5.2.7.1、获取问卷信息以及跳题逻辑数据
export function surveyInfo (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/survey/surveyInfo/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/survey/surveyInfo/query.v`, data, 'post')
}
//5.2.1.3、生成联办快照信息接口
export function doSaveSnapshot (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/unioncontrol/doSaveSnapshot/insert.v`, data, 'post', callFunc,(data)=>{return data})
  }
  return fetchData(`/ApprUnionInterface/api/union/unioncontrol/doSaveSnapshot/insert.v`, data, 'post', callFunc,(data)=>{return data})
}
// 情景式问卷页面涉及接口end

// 办事清单页面涉及接口start
// 根据主题编号/主题快照编号获取主题事项清单
export function getItemDetails (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/itemDetails/query.v`, data, 'get', callFunc,(data)=>{return data})
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/itemDetails/query.v`, data, 'get')
}
// 办事清单页面涉及接口end

// 下载材料清单页面涉及接口start
// 根据主题获取事项材料清单--post方法
export function getBizTypeStuffList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/itemstuff/getBizTypeStuffList/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/getBizTypeStuffList/query.v`, data, 'post')
}
// 根据主题（快照）获取事项材料清单--post方法
export function getStuffList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/itemstuff/getStuffList/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/getStuffList/query.v`, data, 'post')
}
// 下载材料清单页面涉及接口end

// 根据用户获取联办件信息（一件事用）
export function getUnionControlList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/unioncontrol/getUnionControlList/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/unioncontrol/getUnionControlList/query.v`, data, 'post')
}

// 根据主题获取启动办件信息
export function getControlList (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/getControlList/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/getControlList/query.v`, data, 'post')
}

// 基本信息
export function userInfo (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprNetUserInterface/api/user/outUserInfo/query.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprNetUserInterface/api/user/outUserInfo/query.v', msg, 'get')
}
// 基本信息
export function updateUserInfo (data, callFunc) {
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprNetUserInterface/api/user/outUserInfo/1/update.v', data, 'post', callFunc)
  }
  return fetchData('/ApprNetUserInterface/api/user/outUserInfo/1/update.v', data, 'post')
}
// 办理指引页面涉及接口start
export function baseInfo (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/baseInfo/query.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/baseInfo/query.v', msg, 'get')
}
export function winInfo (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/winInfo/query.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/winInfo/query.v', msg, 'get')
}
export function bizTypeExInfo (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/bizTypeExInfo/query.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/bizTypeExInfo/query.v', msg, 'get')
}
// 办理指引页面涉及接口end

// 根据用户获取草稿件信息（一件事用）
export function bizTypeSnapshot (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/bizTypeSnapshot/query.v', msg, 'post', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/bizTypeSnapshot/query.v', msg, 'post')
}

// 删除草稿件（一件事用）
export function delBizTypeSnapshot (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/delBizTypeSnapshot/del.v', msg, 'post', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/delBizTypeSnapshot/del.v', msg, 'post')
}

// 获取联办件的事项办理痕迹
export function getUnionTraceList (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/tracecontrol/getUnionTraceList/query.v', msg, 'post', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/tracecontrol/getUnionTraceList/query.v', msg, 'post')
}

// 根据主题快照获取阶段快照信息
export function getStageSnapshotList (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/stage/getStageSnapshotList.v', msg, 'post', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/stage/getStageSnapshotList.v', msg, 'post')
}

// 根据地区获取热门主题信息
export function hotTypesOnline (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/hotTypesOnline/query.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/hotTypesOnline/query.v', msg, 'get')
}

// 根据主题名称查询主题信息（一件事用）
export function typeInfo (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/biztype/typeInfo/search.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/biztype/typeInfo/search.v', msg, 'get')
}

// 获取一件事数据公开数据
export function themeSettledInfo (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprUnionInterface/api/union/report/themeSettledInfo/query.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprUnionInterface/api/union/report/themeSettledInfo/query.v', msg, 'get')
}

// 获取信息内容列表接口
export function loadContentList (data, callFunc) {
  var msg = data
  if(callFunc && (callFunc.constructor === Function)){
    return fetchData('/ApprCMSInterface/api/cms/loadContentList.v', msg, 'get', callFunc)
  }
  return fetchData('/ApprCMSInterface/api/cms/loadContentList.v', msg, 'get')
}

// 5.2.1.9 获取联办相关信息接口
export function getUnionControlInfo(data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/unioncontrol/getUnionControlInfo/query.v`, data, 'post', callFunc, (data) => { return data })
  }
  return fetchData(`/ApprUnionInterface/api/union/unioncontrol/getUnionControlInfo/query.v`, data, 'post', callFunc, (data) => { return data })
}

// 根据阶段（快照）获取事项（快照）信息--post方法
export function getItemsSnapshot (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/getItemsSnapshot/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/getItemsSnapshot/query.v`, data, 'post')
}
// 获取待办事项的前置事项--post方法
export function getPreItems (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/getPreItems/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/getPreItems/query.v`, data, 'get')
}
// 选择对应的业务分类更新各种快照信息接口--post方法
export function doSaveDifferServ (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/unioncontrol/doSaveDifferServ/insert.v`, data, 'post', callFunc, (data)=>{return data})
  }
  return fetchData(`/ApprUnionInterface/api/union/unioncontrol/doSaveDifferServ/insert.v`, data, 'post', null, (data)=>{return data})
}

// 并联办理时更新事项快照办理状态--post方法
export function updateTranStatus (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/updateTranStatus/update.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/updateTranStatus/update.v`, data, 'post')
}


// 获取评价结果
export function getEvaluateResult (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprEvaluateInterface/api/evaluate/getEvaluateResult.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprEvaluateInterface/api/evaluate/getEvaluateResult.v`, data, 'post')
}

// 并联审批评价--get方法
export function evaluate (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprEvaluateInterface/api/evaluate/evaluate.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprEvaluateInterface/api/evaluate/evaluate.v`, data, 'post')
}
// 获取字典配置接口--get方法
export function getOutnetConfig (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprNetInterface/api/sys/outnetConfig/query.v`, data, 'post', callFunc)
  }
  return fetchData(`/ApprNetInterface/api/sys/outnetConfig/query.v`, data, 'post')
}
// 并联公共材料目录查询（非快照）--get方法
export function getItemCommonStuffs (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/itemstuff/getItemCommonStuffs/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/getItemCommonStuffs/query.v`, data, 'get')
}

// 根据地区编号获取主题数量--get方法
export function loadBizTypeCount (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/loadBizTypeCount/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadBizTypeCount/query.v`, data, 'get')
}

//获取一件事主题统计全市
export function inThemeReport (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/report/oneThing/inThemeReport.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/report/oneThing/inThemeReport.v`, data, 'get')
}

//获取一件事主题统计各区县
export function inAreaThemeReport (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/report/oneThing/inAreaThemeReport.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/report/oneThing/inAreaThemeReport.v`, data, 'get')
}

//获取一件事效能统计
export function statisticsReport (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/report/oneThing/statisticsReport.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/report/oneThing/statisticsReport.v`, data, 'get')
}

//根据地区编号和业务场景编号获取banner图
export function loadBanner (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/loadBanner/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadBanner/query.v`, data, 'get')
}

//根据地区编号和业务场景编号获取banner图
export function getProcessImgData (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionSupport/service/process-definition/diagramLayout.do`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionSupport/service/process-definition/diagramLayout.do`, data, 'get')
}

//根据主题流水号获取问卷基本信息以及默认不隐藏的题目信息
export function loadSurveyInfo (data, callFunc) {
	if (callFunc && (callFunc.constructor === Function)) {
		return fetchData(`/ApprUnionInterface/api/survey/surveyInfo/loadSurveyInfo.v`, data, 'get', callFunc)
	}
	return fetchData(`/ApprUnionInterface/api/survey/surveyInfo/loadSurveyInfo.v`, data, 'get')
}
export function loadNextTopicByOption (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/survey/surveyInfo/loadNextTopicByOption.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/survey/surveyInfo/loadNextTopicByOption.v`, data, 'get')
}
export function surveysnap (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/survey/surveysnap/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/survey/surveysnap/query.v`, data, 'get')
}
export function itemAccords (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/itemAccords/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/itemAccords/query.v`, data, 'get')
}
export function createQRCode (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/createQRCode.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/createQRCode.v`, data, 'get')
}
export function saveSurvey (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/survey/surveysnap/update.v`, data, 'post', callFunc, (data)=>{return data})
  }
  return fetchData(`/ApprUnionInterface/api/survey/surveysnap/update.v`, data, 'post', null, (data)=>{return data})
}
export function loadTypeRsStuffListByTypeSeq (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/itemstuff/loadTypeRsStuffListByTypeSeq.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/loadTypeRsStuffListByTypeSeq.v`, data, 'get')
}
export function downloadAttachFile (data, callFunc, config) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/attachfile/download.v`, data, 'get', callFunc, null, config)
  }
  return fetchData(`/ApprUnionInterface/api/attachfile/download.v`, data, 'get',null, null, config)
}
export function downloadAttachFile_state (data, callFunc, config) {
	if (callFunc && (callFunc.constructor === Function)) {
		return fetchData(`/appr-writ-sign/api/filePreview/downloadFile`, data, 'get', callFunc, null, config)
	}
	return fetchData(`/appr-writ-sign/api/filePreview/downloadFile`, data, 'get',null, null, config)
}
export function queryOptionItems (data, callFunc, config) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/optionItems/query.v`, data, 'get', callFunc, null, config)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/optionItems/query.v`, data, 'get',null, null, config)
}
export function loadParamByKey (data, callFunc, config) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/param/loadByKey`, data, 'get', callFunc, null, config)
  }
  return fetchData(`/ApprUnionInterface/api/union/param/loadByKey`, data, 'get',null, null, config)
}
export function loadPictureStepItemList (data, callFunc, config) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/loadPictureStepItemList`, data, 'get', callFunc, null, config)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadPictureStepItemList`, data, 'get',null, null, config)
}
export function queryOptionStuffs (data, callFunc, config) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/itemstuff/optionStuffs/query.v`, data, 'get', callFunc, null, config)
  }
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/optionStuffs/query.v`, data, 'get',null, null, config)
}

//获取生成导办指南页事项材料快照列表
export function guideSnapshot (data, callFunc) {
	if (callFunc && (callFunc.constructor === Function)) {
		return fetchData(`/ApprUnionInterface/api/union/itemstuff/guideSnapshot/query.v`, data, 'get', callFunc)
	}
	return fetchData(`/ApprUnionInterface/api/union/itemstuff/guideSnapshot/query.v`, data, 'get')
}
//获获取导办指南页主题事项材料列表（非快照）
export function guideItemStuff (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/itemstuff/guide/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/itemstuff/guide/query.v`, data, 'get')
}
//根据主题事项应办清单获取事项申请条件/收费依据清单
export function getApplyAccords (data, callFunc) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/relateditems/applyAccords/query.v`, data, 'get', callFunc)
  }
  return fetchData(`/ApprUnionInterface/api/union/relateditems/applyAccords/query.v`, data, 'get')
}

export function loadLatestDraftUnionInfoByUser (data, callFunc, config) {
  if (callFunc && (callFunc.constructor === Function)) {
    return fetchData(`/ApprUnionInterface/api/union/biztype/loadLatestDraftUnionInfoByUser`, data, 'get', callFunc, null, config)
  }
  return fetchData(`/ApprUnionInterface/api/union/biztype/loadLatestDraftUnionInfoByUser`, data, 'get',null, null, config)
}
